export type IMessageReturnToMessagesScenario = "mem" | "proactive";
export type IMessageReturnToMessagesTitle = "Welcome to Mem" | "Welcome to Mem Proactive";

export const MEM_AGENT_IMESSAGE_MESSAGES_URL = "sms:+12054909188";

export const getIMessageReturnToMessagesTitle = ({
  scenario,
}: {
  scenario: IMessageReturnToMessagesScenario;
}): IMessageReturnToMessagesTitle => {
  if (scenario === "proactive") {
    return "Welcome to Mem Proactive";
  }

  return "Welcome to Mem";
};

export const getIMessageReturnToMessagesUrl = (): URL => new URL(MEM_AGENT_IMESSAGE_MESSAGES_URL);
